const moment = require( 'moment')

const Api = {
    calculateDescription(value) {
        if(!value.description || value.description.length < 1) {
            //return value.raw.shopping_name
            if (value.shopping_measure === 'custom') {
                return this.multiplyUnit(value.unit) + ' ' + value.measure_name + ' of ' + value.raw.shopping_name
            }
        }
        return this.multiplyDescription(value.description)
    },
    ingredientDescription(item, amount) {
        if(!item.description || item.description.length < 1) {
            //return value.raw.shopping_name
            if (item.shopping_measure === 'custom') {
                return Api.multiplyUnit(item.unit, amount) + ' ' + item.measure_name + ' of ' + item.raw.shopping_name
            }
        }
        return Api.multiplyDescription(item.description, amount)
    },
    multiplyUnit(unit, amount) {
        return amount * unit;
    },
    multiplyDescription(description, amount) {
        var newAmounts = []
        var newStr = description.replace(/\[+(.*)\]/g, function(match) {
            let updateMatch = (match.replace('[', '').replace(']', '')) * amount
            newAmounts.push(updateMatch)
            return updateMatch
        });

        let i = 0
        newStr = newStr.replace(/\{+(.*)\}/g, function(match) {
            let updateMatch = (match.replace('{', '').replace('}', ''))
                if(newAmounts[i] > 1) updateMatch += 's'
            return updateMatch;
        });

        return newStr;
    },
    getTotalNutrition (type, servings, ingredient_lists, stream) {
        if (servings < 1) return 0


        let total = 0
        let totals = {}
        let index = 0
        ingredient_lists.forEach(group => {
            group.ingredients.forEach(ingredient => {
                if(!stream) return
                if(ingredient.stream > 0 && parseInt(ingredient.stream) !== parseInt(stream.id)) return
                if(parseInt(stream.id) > 0 && parseInt(ingredient.stream) === 0 && totals[index + '_' + ingredient.position]) return
                totals[index + '_' + ingredient.position] = parseFloat(Api.getTotalIngredientNutrition(type, ingredient))
            })
            index++
        })
        total = Api.sum(totals)
        if (type === 'calories') return Math.round(total / servings)
        return (total / servings).toFixed(2)
    },
    getTotalIngredientNutrition (type, ingredient) {
        if (ingredient) {
            if (ingredient[type] && !ingredient.raw) return ingredient[type]
            if (!ingredient.measure || !ingredient.raw) return 0
            let result = parseFloat(ingredient.unit) * parseFloat(ingredient.measure.weight) / 100 * parseFloat(ingredient.raw[type])
            if (type === 'calories') return Math.round(result / 4.184)

            return parseFloat(result).toFixed(2)
        }
    },
    sum ( obj ) {
        var sum = 0
        for (var el in obj) {
            if (obj.hasOwnProperty(el)) {
                sum += parseFloat(obj[el])
            }
        }
        return sum
    },
    getDayName (dayNum) {
        return moment().day(dayNum).format('dddd')
    }

}

export default Api
